// extracted by mini-css-extract-plugin
export default {"test":"customAutoComplete_test__EYic-"};